import React, { useState } from 'react';
import Grid from "@mui/material/Grid";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from '../../utils/adminAuth';
import './AdminLogin.scss';

const AdminLogin = () => {
  const navigate = useNavigate();

  const [value, setValue] = useState({
    email: '',
    password: '',
  });

  const [showPassword, setShowPassword] = useState(false);

  const changeHandler = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
    validator.showMessages();
  };

  const [validator] = useState(new SimpleReactValidator({
    className: 'errorMessage'
  }));

  const submitForm = (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      const success = loginAdmin(value.email, value.password);
      
      if (success) {
        toast.success('Successfully logged in as Admin!');
        navigate('/admin');
      } else {
        toast.error('Invalid email or password!');
      }
    } else {
      validator.showMessages();
      toast.error('Please fill in all required fields!');
    }
  };

  return (
    <Grid className="adminLoginWrapper">
      <Grid className="adminLoginForm">
        <div className="adminHeader">
          <h2>Admin Login</h2>
          <p>Access Analytics Dashboard</p>
        </div>
        <form onSubmit={submitForm}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                className="inputOutline"
                fullWidth
                placeholder="Admin Email"
                value={value.email}
                variant="outlined"
                name="email"
                label="Email Address"
                InputLabelProps={{
                  shrink: true,
                }}
                onBlur={(e) => changeHandler(e)}
                onChange={(e) => changeHandler(e)}
              />
              {validator.message('email', value.email, 'required|email')}
            </Grid>
            <Grid item xs={12}>
              <TextField
                className="inputOutline"
                fullWidth
                placeholder="Password"
                value={value.password}
                variant="outlined"
                name="password"
                type={showPassword ? 'text' : 'password'}
                label="Password"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        onMouseDown={(e) => e.preventDefault()}
                        edge="end"
                        style={{ color: '#1e3a8a' }}
                      >
                        <i 
                          className={showPassword ? 'ti-eye' : 'ti-eye-off'}
                          style={{ 
                            color: '#1e3a8a', 
                            fontSize: '18px',
                            display: 'inline-block'
                          }}
                        ></i>
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                onBlur={(e) => changeHandler(e)}
                onChange={(e) => changeHandler(e)}
              />
              {validator.message('password', value.password, 'required')}
            </Grid>
            <Grid item xs={12}>
              <Grid className="formFooter">
                <Button fullWidth className="cBtnTheme" type="submit">
                  Login to Analytics
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
        <div className="shape-img">
          <i className="ti-bar-chart"></i>
        </div>
      </Grid>
    </Grid>
  );
};

export default AdminLogin;

